import { createSelector } from 'reselect'

import { selectComposedReportState } from './selectComposedReportState'

export const selectProductsSelectValue = createSelector(
  [selectComposedReportState],
  ({ products }) => products
)
